export default __webpack_public_path__ + "static/media/small.d6a8db39.jpg";